import React from "react";

const FilterButton = ({ target, noMargin = false }) => {
  return (
    <span
      className={`btn btn-primary font-weight-bold letter-spacing btn-md collapsed ${
        !noMargin ? "mr-5" : ""
      }`}
      data-target={`#${target}`}
      data-toggle="collapse"
    >
      Filter
    </span>
  );
};

export default FilterButton;
